import React, { useCallback, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import EditorGalleryEdit from '@wix/da-ds/pkg/Icons/24x24/EditorGalleryEdit';
import { getStoredCallback } from '../../../../components/utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';
const Edit = ({ editor })=>{
    const { t } = useTranslation('editor');
    const manageDeviation = useCallback(()=>{
        const attribs = editor.getAttributes('da-gallery');
        const onManageMedia = getStoredCallback(editor, 'onManageMedia');
        onManageMedia && onManageMedia((deviations)=>{
            if (deviations.length > 0) {
                editor.chain().focus().daGalleryAddDeviations(deviations, true).run();
            }
        }, {
            title: 'Manage Gallery',
            initialDeviationSet: attribs.deviations
        });
    }, [
        editor
    ]);
    // don't show the button on mobile bc, currently, MM won't display on mobile
    // https://phrac.deviantart.net/source/da-frontend/browse/master/projects/da-shared-react/src/MediaPopup/MediaManager/MediaManager.tsx$137-138
    const isMobile = useContext(MobileContext);
    if (isMobile) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        icon: EditorGalleryEdit,
        onClick: manageDeviation,
        tooltipText: t('ext.gallery.button.manage')
    });
};
Edit.displayName = 'Edit';
export default Edit;

//# sourceMappingURL=Edit.js.map